<template>
  <vi-tooltip
    :width="popoverWidth"
    :trigger="popoverTrigger"
    :placement="popoverPlacement"
    :disabled="!isHasHoverContent"
    class="ttam-ad-format-common-card-popover"
    effect="light"
  >
    <div
      :class="['ttam-ad-format-common-card-container', active ? 'active' : '', disabled ? 'disabled' : '']"
      @click="handleClick"
    >
      <div class="ttam-ad-format-common-card-content">
        <slot />
      </div>
    </div>

    <div slot="content">
      <slot name="tip">
        {{ tip }}
      </slot>
    </div>
  </vi-tooltip>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';

const name = 'ttam-ad-format-common-card';

export default defineComponent({
  name,

  props: {
    tip: { type: String, default: '' },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    popoverWidth: { type: Number, default: 264 },
    popoverTrigger: { type: String, default: 'hover' },
    popoverPlacement: { type: String, default: 'right-start' },
    disabledTooltip: { type: Boolean, default: false },
  },

  setup(props, ctx) {
    const isHasHoverContent = computed(
      () => Boolean(props.tip) || Boolean(ctx.slots.tip) || Boolean(!props.disabledTooltip),
    );

    const handleClick = () => {
      if (props.disabled) {
        return;
      }
      ctx.emit('change');
    };

    return {
      isHasHoverContent,
      handleClick,
    };
  },
});
</script>

<style lang="scss">
.ttam-ad-format-common-card {
  &-popover {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  &-container {
    display: flex;
    box-sizing: border-box;
    border-radius: 4px;
    background: $--color-group3-9;
    outline: 1px solid $--color-group3-9;
    cursor: pointer;

    &:focus {
      outline-width: 1px !important;
    }

    &:hover {
      background: $--color-group3-8;
      .ttam-ad-format-common-card-content {
        border-color: $--color-group3-8;
      }
    }

    &.active {
      background: white;
      outline-color: $--color-group1-5;

      .ttam-ad-format-common-card-content {
        color: $--color-group1-5;
        border-left-color: $--color-group1-5;
        box-shadow: inset 4px 0px 0px $--color-group1-5;
      }
    }

    &.disabled {
      cursor: not-allowed;
      user-select: none;

      &:hover {
        box-shadow: none;
      }

      .ttam-ad-format-common-card-content {
        width: 100%;
        background-color: $--color-group3-9;
        border-left: none;
        color: #bdbdbd;
        .ttam-ad-format-normal-title-sub {
          color: #bdbdbd;
        }
      }
      &.active {
        outline-color: #fda3b2;
        .ttam-ad-format-common-card-content {
          box-shadow: inset 4px 0px 0px #fda3b2;
          background: white;
        }
        .ttam-ad-format-normal-title-label {
          color: #fda3b2;
        }
      }
    }

    .ttam-ad-format-common-card-content {
      padding: 12px;
      border-left: 1px solid $--color-group3-9;
      border-radius: 4px;
    }
  }
}
</style>
